import { useState } from "react";
import { Checkbox, CircularProgress, FormControlLabel, List, ListItem } from "@mui/material";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { selectUserById, updateLensPermission } from "redux/slices/client";
import { ErrorOutlineTwoTone } from "@mui/icons-material";
import { NamedLens, Permission } from "generated/graphql";

import { Checkmark } from "components/Icons";
import { selectLenses } from "redux/slices/client";
import { useParamNumbers } from "helpers/hooks/useParamNumbers";
import { Navigate } from "react-router";

enum LensPermissionSaveState {
  Saved,
  Saving,
  Error,
  Initial,
}
const UserLensAccess = () => {
  const { userId } = useParamNumbers(["userId"]);
  const user = useAppSelector((state) => selectUserById(state, userId));

  if (user === undefined) {
    return <Navigate to="/users" replace />;
  }

  const dispatch = useAppDispatch();
  const isOwner = user?.permissions.includes(Permission.Owner);
  const activeUserLenses = new Set<number>(user?.lenses.map((lens) => lens.id));
  const lenses = useAppSelector(selectLenses);
  const [statusIconState, setStatusIconState] = useState<LensPermissionSaveState>(LensPermissionSaveState.Initial);
  const lensStatusIcon = () => {
    switch (statusIconState) {
      case LensPermissionSaveState.Saving:
        return <CircularProgress size={23} disableShrink />;
      case LensPermissionSaveState.Saved:
        return <Checkmark size={23} />;
      case LensPermissionSaveState.Error:
        return <ErrorOutlineTwoTone color="error" />;
      default:
        undefined;
    }
  };
  const onLensCheckboxClick = (lens: NamedLens, checked: boolean) => {
    setStatusIconState(LensPermissionSaveState.Saving);
    if (userId !== undefined)
      dispatch(updateLensPermission({ userId, lens, value: checked }))
        .unwrap()
        .then(() => {
          setStatusIconState(LensPermissionSaveState.Saved);
        })
        .catch(() => {
          setStatusIconState(LensPermissionSaveState.Error);
        });
  };
  return (
    <>
      {isOwner === undefined || !isOwner ? (
        <div className="flex flex-col h-full min-h-0">
          <div className="flex items-center gap-2">
            <p className="text-2xl font-bold">Lens Access</p>
            {lensStatusIcon()}
          </div>
          <div className="overflow-auto min-w-64 max-w-96 min-h-0">
            <List>
              {lenses.map((lens, index) => (
                <ListItem key={lens.id} dense>
                  <FormControlLabel
                    control={
                      <Checkbox
                        sx={{ display: "inline-block" }}
                        checked={activeUserLenses.has(lens.id)}
                        onChange={(event) =>
                          onLensCheckboxClick({ name: lens.name, id: lens.id }, event.target.checked)
                        }
                        key={index}
                      />
                    }
                    label={lens.name}
                  />
                </ListItem>
              ))}
            </List>
          </div>
        </div>
      ) : (
        <p className="font-bold text-2xl mb-2">Full Lens Access</p>
      )}
    </>
  );
};

export default UserLensAccess;
